import { Tag, type TagProps } from "@blueprintjs/core";
import { useGetMediaQuery } from "@package/ui-gql/index-data-access";
import { useMemo } from "react";

export type MediaTagProps = TagProps & {
  id?: string;
  onRemoveMedia: () => void;
};

export function MediaTag({ id, onRemoveMedia, ...tagProps }: MediaTagProps) {
  const {
    data: dataMedia,
    loading: loadingMedia,
    error: errorMedia,
  } = useGetMediaQuery({
    variables: { id: id ?? "" },
    skip: !id,
  });

  const mediaTagProps = useMemo<TagProps>(() => {
    if (loadingMedia) {
      return {
        title: "Loading...",
      };
    }
    if (errorMedia) {
      return {
        intent: "danger",
        title: "Failed loading media",
        onRemove: onRemoveMedia,
      };
    }
    if (dataMedia) {
      return {
        intent: dataMedia?.item ? "none" : "danger",
        title: dataMedia?.item?.name ?? "Unknown",
        onRemove: onRemoveMedia,
      };
    }

    return {
      title: "Select media file",
    };
  }, [dataMedia, errorMedia, loadingMedia, onRemoveMedia]);

  return (
    <Tag {...tagProps} {...mediaTagProps}>
      {mediaTagProps.title}
    </Tag>
  );
}
